import { render, staticRenderFns } from "./company-about.vue?vue&type=template&id=c6d69a88&scoped=true&lang=pug"
import script from "./company-about.vue?vue&type=script&lang=ts"
export * from "./company-about.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d69a88",
  null
  
)

export default component.exports